import React from 'react'

function Gamedev() {
  return (
    <div>Gamedev</div>
  )
}

export default Gamedev